import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import { MarketingLayout } from "@/components/MarketingLayout";
import Home from "@/pages/Home";
import Advisory from "@/pages/Advisory";
import Mediation from "@/pages/Mediation";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import PortalLayout from "@/pages/portal/PortalLayout";
import Documents from "@/pages/portal/Documents";
import Meetings from "@/pages/portal/Meetings";
import SharedLibrary from "@/pages/portal/SharedLibrary";
import Feedback from "@/pages/portal/Feedback";
import AdminClients from "@/pages/admin/AdminClients";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminLibrary from "@/pages/admin/AdminLibrary";
import AdminFeedback from "@/pages/admin/AdminFeedback";

const Protected = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/portal/documents" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/advisory" element={<Advisory />} />
              <Route path="/mediation" element={<Mediation />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<Protected><PortalLayout /></Protected>}>
              <Route index element={<Navigate to="documents" replace />} />
              <Route path="documents" element={<Documents />} />
              <Route path="meetings" element={<Meetings />} />
              <Route path="shared" element={<SharedLibrary />} />
              <Route path="feedback" element={<Feedback />} />
            </Route>
            <Route path="/admin" element={<Protected adminOnly><PortalLayout /></Protected>}>
              <Route index element={<Navigate to="clients" replace />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="library" element={<AdminLibrary />} />
              <Route path="enquiries" element={<AdminEnquiries />} />
              <Route path="feedback" element={<AdminFeedback />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
